import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claims`;

export interface SetClaimReasonCommandArgs {
  claimId: string;
  reasonId: string;
  reasonComment?: string;
}

export const setClaimReasonRequest = ({
  claimId,
  reasonId,
  reasonComment,
}: SetClaimReasonCommandArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimId}/reason`,
  config: {
    method: SUPPORTED_METHODS.PUT,
    json: {
      reasonId,
      reasonComment: reasonComment || '',
      diagnosticComment: '',
    },
  },
});

export const setClaimReasonCommand = async (
  args: SetClaimReasonCommandArgs,
): Promise<BackResponse<Record<string, unknown>> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Record<string, unknown>>>(
      setClaimReasonRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
